import { api } from './api'

//const apiVersion = 'v2'

export const secondaryProcessesApi = api
    .enhanceEndpoints({
        addTagTypes: ['SecondaryProcesses'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getSecondaryProcesses: builder.query({
                query: ({ organisationId, requestParams }) => ({
                    url: `/organisations/${organisationId}/secondary-processes`,
                    params: requestParams,
                }),
                providesTags: (result, _error, _arg) =>
                    result
                        ? [
                              { type: 'SecondaryProcesses', id: 'LIST' },
                              ...result.map(({ secondaryProcessId }) => ({
                                  type: 'SecondaryProcesses',
                                  id: secondaryProcessId,
                              })),
                          ]
                        : [{ type: 'SecondaryProcesses', id: 'LIST' }],
                transformResponse: (response) => {
                    const sorted = response?.sort((a, b) => {
                        if (a.index === b.index) {
                            return a.isDeleted ? -1 : 1
                        }
                        return a.index - b.index
                    })
                    return sorted
                },
            }),

            getSecondaryProcess: builder.query({
                query: ({ organisationId, requestParams, secondaryProcessId }) => ({
                    url: `/organisations/${organisationId}/secondary-processes/${secondaryProcessId}`,
                    params: requestParams,
                }),
                providesTags: (_result, _error, arg) => [{ type: 'SecondaryProcesses', id: arg.secondaryProcessId }],
            }),
        }),
    })

export const { useGetSecondaryProcessQuery, useGetSecondaryProcessesQuery, useLazyGetSecondaryProcessesQuery } =
    secondaryProcessesApi
